import React, { useContext, useEffect } from "react";
import Row from "@amzn/meridian/row";
import Tag from "@amzn/meridian/tag";
import Column from "@amzn/meridian/column";
import ControlGroup from "@amzn/meridian/control-group";
import RadioButton from "@amzn/meridian/radio-button";
import { CycleFilterContext } from "./context/CycleFilterContext";
import { getCycleDataFromParent } from "../handler/ParentDataHandler";
import { FormattedMessage } from "react-intl";

const CycleFilter = () => {
  const { cycles, dispatch } = useContext(CycleFilterContext);
  useEffect(() => {
    getCycleDataFromParent().then((cycleData) => {
      dispatch({ type: "INITIALIZE_CYCLES", cycleData });
    });
  }, []);
  return (
    <Column spacing="small" spacingInset="none large">
      <Row width="100%" spacingInset="medium large" backgroundColor="secondary">
        <ControlGroup
          label={
            <FormattedMessage id="cycle_filter.cycle" defaultMessage="Cycle" />
          }
          name="cycles"
          onChange={(data) => dispatch({ type: "SELECT_CYCLE", cycle: data })}
          value={cycles.selectedCycles[0]}
        >
          {cycles.allCycles.map((cycle) => {
            return (
              <RadioButton value={cycle.cycleName}>
                {cycle.displayableName}
              </RadioButton>
            );
          })}
        </ControlGroup>
      </Row>
      <Row width="100%" spacingInset="none">
        <div className="filter-tag">
          {cycles.selectedCycles.map((cycle) => {
            return (
              <Tag key={cycle} type="theme">
                {cycle}
              </Tag>
            );
          })}
        </div>
      </Row>
    </Column>
  );
};

export default CycleFilter;



// WEBPACK FOOTER //
// ./src/components/overview/CycleFilter.js